import React from "react";
import { ScrollArea } from "@mantine/core";
import { IconFileSpreadsheet, IconList, IconUser, IconDatabase, IconFileAnalytics } from "@tabler/icons-react";
import { LinksGroup } from "./NavbarLinksGroup";
import classes from "../css/NavbarNested.module.css";
import { useUser } from "../tools/Context";

const mockdata = [
  {
    label: "Marchés",
    icon: IconList,
    initiallyOpened: true,
    links: [{ label: "Voir mes marchés", link: "/myMarket", notifications: 0 }],
  },
  {
    label: "Ordre de service",
    icon: IconFileSpreadsheet,
    initiallyOpened: true,
    links: [
      { label: "Voir mes OS", link: "/myOS", notifications: 0 },
      { label: "Créer un OS", link: "/createOS", notifications: 0 },
      { label: "Brouillons", link: "/brouillon", notifications: 1 },
    ],
  },
  {
    label: "Décomptes",
    icon: IconFileAnalytics,
    initiallyOpened: true,
    links: [
      { label: "Voir les décomptes", link: "/myDecompte", notifications: 0 },
      { label: "Créer un décompte", link: "/newDecompte", notifications: 0 },
    ],
  },
];

const mockdataProjectManager = [
  {
    label: "Marchés",
    icon: IconList,
    initiallyOpened: true,
    links: [{ label: "Voir mes marchés", link: "/myMarket", notifications: 0 }],
  },
  {
    label: "Ordre de service",
    icon: IconFileSpreadsheet,
    initiallyOpened: true,
    links: [{ label: "Voir les OS", link: "/myOS", notifications: 0 }],
  },
  {
    label: "Décomptes",
    icon: IconFileAnalytics,
    initiallyOpened: true,
    links: [{ label: "Voir les décomptes", link: "/myDecompte", notifications: 0 }],
  },
];

const mockdataAdministrator = [
  {
    label: "Administration",
    icon: IconUser,
    initiallyOpened: true,
    links: [
      { label: "Marchés", link: "/myMarket", notifications: 0 },
      { label: "Ordre de services", link: "/myOS", notifications: 0 },
      {
        label: "Gestion des utilisateurs",
        link: "/userManagement",
        notifications: 0,
      },
      { label: "Décomptes", link: "/myDecompte", notifications: 0 },
    ],
  },
  {
    label: "Import, Export",
    icon: IconDatabase,
    initiallyOpened: true,
    links: [
      { label: "Export", link: "/exportOsData", notifications: 0 },
      { label: "Import", link: "/importData", notifications: 0 },
    ],
  },
];

const mockdataSupplier = [
  {
    label: "Marchés",
    icon: IconList,
    initiallyOpened: true,
    links: [
      {
        label: "Voir mes marchés",
        link: "/myMarket",
        notifications: 0,
      },
    ],
  },
  {
    label: "Ordre de service",
    icon: IconFileSpreadsheet,
    initiallyOpened: true,
    links: [{ label: "Voir les OS", link: "/myOS", notifications: 0 }],
  },
  {
    label: "Décomptes",
    icon: IconFileAnalytics,
    initiallyOpened: true,
    links: [{ label: "Voir les décomptes", link: "/myDecompte", notifications: 0 }],
  },
];

export function Navbar() {
  const { role, isratp } = useUser();
  console.log(role);

  let links;
  if (role === "administrateur") {
    links = mockdataAdministrator;
  } else if (role === "chef de projet") {
    links = mockdataProjectManager;
  } else if (role === "titulaire de marché") {
    links = mockdataSupplier;
  } else {
    links = mockdata;
  }

  return (
    <>
      <div>
        <nav className={classes.navbar}>
          <ScrollArea className={classes.links}>
            <div className={classes.linksInner}>
              {links.map((item) => (
                <LinksGroup {...item} key={item.label} isratp={isratp} />
              ))}
            </div>
          </ScrollArea>
        </nav>
      </div>
    </>
  );
}
